// Document Vault and client documents: drafts: the routes and the sidebar rows of `wealth.crm.document-vault.drafts` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.crm.document-vault.drafts',
    routes: [
        {
            frontend: 'desk',
            path: 'document-drafts',
            lazy: () => import('@/pages/desk/document-drafts/page'),
        },
        {
            frontend: 'desk',
            path: 'document-drafts/:id',
            lazy: () => import('@/pages/desk/document-drafts/draft/page'),
        },
    ],
    nav: [
        // Template-filled documents awaiting approval. SEP-213 took the row off
        // the sidebar, but the MCP document tool hands an IM a deep link to the
        // draft it just prepared, so the route stays open (`sidebarHidden`).
        {
            frontend: 'desk',
            key: 'document-drafts',
            label: 'Document Drafts',
            href: '/desk/document-drafts',
            icon: 'FileCheck',
            group: 'advice-suitability',
            order: 2200,
            sidebarHidden: true,
        },
    ],
});
